import React, { useState, useEffect } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import SparkApi from "../api/SparkApi";
import authApi from "../api/authApi"; // Added By jaseem 
import PubSub from "pubsub-js";
import Select from "react-select";
import jwt_decode from "jwt-decode";

const UserEdit = () => {
    const location = useLocation();
    const navigate = useNavigate();
    //const [user, setuser] = useState(location.state);
    const [user, setUser] = useState(location.state ? location.state : {});
    ////console.log('user edit', user)
    let name = user.firstname
    const [optionUsers, setOptionUsers] = useState([]);
    const [option, setoption] = useState();
    const [selectedUser, setSelectedUser] = useState('');
    const [validated, setValidated] = useState(false);
    const [show, setShow] = React.useState(false);

    useEffect(() => {


        if (user.id) {
            //console.log('if call')
            let temp = {}
            temp.value = user.managerid;
            temp.label = user.managername;
            setoption(temp);
            setUser({ ...user, managerid: user.managerid, managername: user.managername });
        } else {
            let userInfo = jwt_decode(localStorage.getItem('token'));
            //console.log('userInfo', userInfo);
            let temp = {}
            temp.value = userInfo.id;
            temp.label = userInfo.username;
            setoption(temp);
            setUser({ ...user, managerid: userInfo.id, managername: userInfo.username });

        }
        async function init() {
            const result = await SparkApi.fetchUsers();

            if (result) {
                let ar = [];
                var obj = {};
                obj.value = null;
                obj.label = '-- Select Manager --';
                ar.push(obj);
                result.map((item) => {
                    if (item.userrole !== 'USER') {
                        var obj = {};
                        obj.value = item.id;
                        obj.label = item.username;
                        ar.push(obj);
                    }

                });
                setOptionUsers(ar);
            } else {
                setOptionUsers([]);
            }
        }
        init();
    }, []);

    const checkRequredFields = () => {
        ////console.log(selectedUser)
        if ((user.firstname && user.firstname.trim() !== '') && user.lastname &&
            user.email && user.userrole && user.phone && user.managerid){
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        console.log('handle submit call', user)
        e.preventDefault();
        if (checkRequredFields()) {
            setValidated(true);
            return;
        }
        if (user?.userrole === 'ADMIN' && user.usertype === '') {
            setValidated(true);
            return;
        }

        //========= Logic to perform Create or Edit ======
        let result = {};
        // if(user?.userrole === 'ADMIN' && user?.id === '' || user?.id === null || user?.id === undefined) {
        //     let existingUser = await SparkApi.fetchUserByUsertype(user?.usertype);
        //     //console.log('existingUser',existingUser)
        //     if (existingUser && existingUser?.length > 0) {
        //         PubSub.publish("RECORD_ERROR_TOAST", {
        //             title: "Record Save Error",
        //             message: "Already User exists",
        //         });
        //         return;
        //     } 
        // }
        if (user.id) {
            ////console.log('if updated')
            const passwordChanged = user.password && String(user.password).trim() !== ''; // Added By jaseem  (check and trim the user password)
            result = await SparkApi.saveUser(user);
            ////console.log('result save', result)
            ////console.log('if create')
            if (result.success) {
                PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Record Saved",
                    message: passwordChanged && result.sessionInvalidated
                        ? "Record saved. Please login again with your new password."
                        : "Record saved successfully",
                });
                // Added By Jaseem: Logout current user after self-password change when session is invalidated. 
                // Added By Jaseem: Automatically logout the user from all devices when the password is changed.
                if (passwordChanged && result.sessionInvalidated) {
                    const token = localStorage.getItem("token");
                    if (token) {
                        try {
                            const me = jwt_decode(token);
                            if (me.id === user.id) {
                                authApi.logout();
                                return;
                            }
                        } catch (e) { /* ignore */ }
                    }
                }
                navigate(`/users/${user.id}`, { state: user });
            } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                    title: "Record Save Error",
                    message: result.errors,
                });
            }
        } else {
            console.log("USER",user)
            result = await SparkApi.createUser(user);
            ////console.log('result create', result)
            if (result.success) {
                PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Record Saved",
                    message: "Record saved successfully",
                });
                navigate(`/users/${result.id}`, { state: result });
            } else {
                PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Save Error', message: result.errors });

            }
        }
    }

    const handleCancel = () => {
        if (user.id) {
            navigate(`/users/${user.id}`, { state: user })

        } else {
            navigate(`/users/`)
        }

    }


    const handleChange = (e) => {
        ////console.log(e.target.checked)
        ////console.log('user', user)
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const handleActive = (e) => {


        ////console.log(e.target.checked)
        setUser({ ...user, [e.target.name]: e.target.checked });

    };



    const handleUsers = (event) => {
        console.log("manager option", event)
        event.value ? setShow(false) : setShow(true);
        setoption(event);
        setSelectedUser(event)
        setUser({ ...user, managerid: event?.value, managername: event?.label });
        // console.log("manager option",option)
    }

    return (
        <Container className="view-form">
            <Row >
                <Col></Col>
                <Col lg={8} className="pb-1 pt-2">
                    <Link className="nav-link" to="/users">
                        Home <i className="fa-solid fa-chevron-right"></i> <div style={{ color: "#23468c", display: "inline" }}>Users</div>
                    </Link>
                </Col>
                <Col></Col>
            </Row>
            <Row>
                <Col></Col>
                <Col lg={8}>
                    <Form
                        className="mt-3"
                        onSubmit={handleSubmit}
                        noValidate
                        validated={validated}
                    >
                        <Row className="view-form-header align-items-center">
                            <Col lg={8}>

                                {
                                    user.id === undefined ? <h6>Create User</h6> : <h6>Edit User</h6>
                                }
                                <h4></h4>

                            </Col>
                            <Col lg={4} className="d-flex justify-content-end">
                                <Button className="btn-sm mx-2" onClick={handleSubmit}>
                                    Save
                                </Button>
                                <Button
                                    className="btn-sm"
                                    variant="danger"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                        <Row className="ibs-edit-form">
                            <Col>
                                <Alert variant="danger" show={show} className="error-alert my-4 ">
                                    Please provide manager
                                </Alert>
                            </Col>
                            <Row lg={12} className="mb-4">
                                <Col lg={6}>
                                    <Form.Group className="mx-3" controlId="formBasicFirstName">
                                        <Form.Label
                                            className="form-view-label"
                                            htmlFor="formBasicFirstName"
                                        >
                                            First Name
                                        </Form.Label>
                                        <Form.Control
                                            style={{ height: "36px" }}
                                            required
                                            type="text"
                                            name="firstname"
                                            placeholder="Enter First Name"
                                            value={user.firstname}
                                            onChange={handleChange}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide first name.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mx-3" controlId="formBasicLastName">
                                        <Form.Label
                                            className="form-view-label"
                                            htmlFor="formBasicLastName"
                                        >
                                            Last Name
                                        </Form.Label>
                                        <Form.Control
                                            style={{ height: "36px" }}
                                            required
                                            type="text"
                                            name="lastname"
                                            placeholder="Enter Last Name"
                                            value={user.lastname}
                                            onChange={handleChange}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide last name.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                <Col lg={6}>
                                    <Form.Group className="mx-3" controlId="formBasicEmail">
                                        <Form.Label
                                            className="form-view-label"
                                            htmlFor="formBasicEmail"
                                        >
                                            Email
                                        </Form.Label>
                                        <Form.Control
                                            style={{ height: "36px" }}
                                            type="email"
                                            required
                                            name="email"
                                            placeholder="Enter Email"
                                            value={user.email}
                                            onChange={handleChange}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide valid email.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mx-3" controlId="formBasicPhone">
                                        <Form.Label
                                            className="form-view-label"
                                            htmlFor="formBasicPhone"
                                        >
                                            Phone
                                        </Form.Label>
                                        <Form.Control
                                            style={{ height: "36px" }}
                                            required
                                            type="phone"
                                            name="phone"
                                            minLength="10"
                                            maxLength="10"
                                            placeholder="Enter Phone"
                                            value={user.phone}
                                            onKeyDownCapture={e => { (e?.key == " " || ((e.key.length == 1) && isNaN(e.key))) && e.preventDefault() }}
                                            onChange={handleChange}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide valid phone.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                {!user.id ? <Col lg={6}>
                                    <Form.Group className="mx-3" controlId="formBasicpassword">
                                        <Form.Label
                                            className="form-view-label"
                                            htmlFor="formBasicpassword"
                                        >
                                            Password
                                        </Form.Label>
                                        <Form.Control
                                            style={{ height: "36px" }}
                                            required
                                            type="password"
                                            name="password"
                                            placeholder="Enter Password"
                                            value={user.password}
                                            onChange={handleChange}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter 6 character minimum.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                </Col>
                                    : ''}
                                <Col lg={6}>
                                    <Form.Group className="mx-3">
                                        <Form.Label className="form-view-label">User Type</Form.Label>
                                        <Form.Select name="usertype" onChange={handleChange} required value={user.usertype} style={{ height: "36px" }}>
                                            <option value="">-- Select User Type --</option>
                                            <option value="Sales Admin">Sales Admin</option>
                                            <option value="Installation Admin">Installation Admin</option>
                                            <option value="Accounts Admin">Accounts Admin</option>
                                            <option value="Installation Engineer">Installation Engineer</option>
                                            <option value="Business Development Executive">Business Development Executive</option>
                                            <option value="Customer Relationship Executive">Customer Relationship Executive</option>
                                            <option value="Office Coordinator">Office Coordinator</option>
                                            <option value="Office Executive">Office Executive</option>
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select user type.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                {!user.id ?
                                    <Col lg={6}>
                                        <Form.Group className="mx-3">
                                            <Form.Label className="form-view-label">Role</Form.Label>
                                            <Form.Select name="userrole" onChange={handleChange} required value={user.userrole} style={{ height: "36px" }}>
                                                <option value="">-- Select User Role --</option>
                                                <option value="ADMIN">Admin</option>
                                                <option value="USER">User</option>

                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select user role.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    : ''}


                                <Col >
                                    <Form.Group className="mx-3" controlId="formBasicOwner">
                                        <Form.Label className="form-view-label" htmlFor="formBasicOwner" >
                                            Manager
                                        </Form.Label>
                                        <Select

                                            name="ownerid"
                                            value={option && option}
                                            className={`custom-select username rounded-3 ${show ? 'border-start-2 border-danger' : 'border-start-2 border-success'} `}
                                            onChange={handleUsers}
                                            options={optionUsers}
                                            getOptionValue={(option) => option.value}
                                            placeholder="-- Select Manager --"
                                        // isClearable
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please select manager.
                                        </Form.Control.Feedback>


                                    </Form.Group>
                                </Col>

                                <Col lg={6}>
                                    <Form.Group className="mx-3" controlId="formBasicPin">
                                        <Form.Label
                                            className="form-view-label"
                                            htmlFor="formBasicPin"
                                        >
                                            Active

                                        </Form.Label>

                                        <Form.Check
                                            inline
                                            name="isactive"
                                            type="checkbox"
                                            value={user.isactive && user.isactive === true}
                                            checked={user.isactive && user.isactive === true}
                                            id="inline-checkbox-9"
                                            onChange={handleActive}
                                            defaultChecked={true}
                                        />
                                    </Form.Group>
                                </Col>

                            </Row>
                        </Row>
                    </Form>
                </Col>
                <Col></Col>
            </Row>
        </Container>
    )
}

export default UserEdit
